import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["src", "poster", "muted", "loop", "autoplay", "width", "height"]
const _hoisted_2 = ["src", "type"]

import { computed } from "vue";
import WebpImage from "../image/webp-image.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'webp-video',
  props: {
    src: {},
    cssClass: {},
    alt: {},
    width: {},
    height: {},
    isLazyload: { type: Boolean, default: false },
    loadingPriority: {},
    media: {},
    get2x: { type: Boolean, default: false },
    videoHasSound: { type: Boolean, default: false },
    loopVideo: { type: Boolean, default: true },
    isVideoAllowed: { type: Boolean, default: true }
  },
  emits: ["mediaLoaded"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const videoSources = computed(() => {
    if (!props.src || props.src.trim() === "") {
        return {
            videoUrl: null,
            fallbackImageUrl: "",
        };
    }

    const images = props.src.split("|").filter(Boolean);
    const isVideo = images[0].includes(".webm") || images[0].includes(".mp4");

    const fallbackImageUrl = isVideo ? (images.length > 1 ? images[1] : "") : images[0];
    const videoUrl = isVideo ? images[0] : null;

    return {
        videoUrl,
        fallbackImageUrl,
    };
});

const isVideo = computed(() => props.src.includes(".webm") || props.src.includes(".mp4"));

return (_ctx: any,_cache: any) => {
  return (isVideo.value && _ctx.isVideoAllowed)
    ? (_openBlock(), _createElementBlock("video", {
        key: 0,
        class: _normalizeClass(_ctx.cssClass),
        src: videoSources.value.videoUrl,
        poster: videoSources.value.fallbackImageUrl,
        playsinline: "",
        muted: !_ctx.videoHasSound,
        loop: _ctx.loopVideo && !_ctx.videoHasSound,
        autoplay: !_ctx.videoHasSound,
        width: _ctx.width,
        height: _ctx.height,
        onLoadeddata: _cache[0] || (_cache[0] = ($event: any) => (emit('mediaLoaded')))
      }, [
        _createElementVNode("source", {
          src: videoSources.value.videoUrl,
          type: videoSources.value.videoUrl.includes('.webm') ? 'video/webm' : 'video/mp4'
        }, null, 8, _hoisted_2)
      ], 42, _hoisted_1))
    : (_openBlock(), _createBlock(WebpImage, {
        key: 1,
        src: _ctx.src,
        cssClass: _ctx.cssClass,
        alt: _ctx.alt,
        width: _ctx.width,
        height: _ctx.height,
        isLazyload: _ctx.isLazyload,
        loadingPriority: _ctx.loadingPriority,
        media: _ctx.media,
        get2x: _ctx.get2x,
        onImageLoaded: _cache[1] || (_cache[1] = ($event: any) => (emit('mediaLoaded')))
      }, null, 8, ["src", "cssClass", "alt", "width", "height", "isLazyload", "loadingPriority", "media", "get2x"]))
}
}

})